import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import * as Colors from 'material-ui/styles/colors';
import SingleSelect from './SingleSelect';
import {FIELD_WIDTH} from '../consts';
import AbstractListerField from './AbstractListerField';
import memoize from 'memoize-one';

export default class ListerSingleSelect extends AbstractListerField {
  constructor(props) {
    super(props);
    this.getSingleSelectProps = memoize((dataSet, parentValue) => {
      const {orderBy, parentName, dataSourceConfig} = this.props;
      let values;
      if (dataSourceConfig) {
        values = dataSet;
      } else {
        if (parentName) {
          dataSet = dataSet[parentValue];
        }
        values = _.isArray(dataSet) ? dataSet : _.keys(dataSet);
      }
      if (orderBy) {
        values = _.orderBy(values, orderBy.iteratees, orderBy.orders);
      }
      return {dataSource: values, dataSourceConfig};
    });
  }

  updateFieldValue = value => {
    const {onChange, type} = this.props;
    if (type === 'number' && value === null) {
      value = 0;
    }
    onChange(value);
  };

  render() {
    let {value} = this.props;
    const {width, children, parentName, dataSet, parentValue, disabled, id} = this.props;
    if (_.isArray(value)) {
      value = value[0];
    }
    return (
      <div>
        <SingleSelect
          id={id}
          {...this.getSingleSelectProps(dataSet, parentValue)}
          value={value}
          style={{width}}
          onChange={this.updateFieldValue}
          disabled={(parentName && _.isEmpty(parentValue)) || disabled}
          floatingLabelStyle={{width: 'max-content', whiteSpace: 'nowrap'}}
          {..._.pick(this.props, [
            'clearable',
            'freeText',
            'onFocus',
            'onBlur',
            'errorText',
            'errorStyle',
            'floatingLabelText',
          ])}
        />
        {children &&
          _.map(children, (child, key) => {
            return (
              <div key={key} style={{height: 60, display: 'flex', alignItems: 'center', marginTop: 15}}>
                <div
                  style={{
                    width: 20,
                    height: 40,
                    marginBottom: 10,
                    marginRight: 10,
                    borderWidth: 1,
                    borderColor: Colors.grey400,
                    borderStyle: 'none none dotted dotted',
                  }}
                />
                {child}
              </div>
            );
          })}
      </div>
    );
  }
}

ListerSingleSelect.propTypes = {
  fieldName: PropTypes.string,
  onChange: PropTypes.func,
  floatingLabelText: PropTypes.string,
  orderBy: PropTypes.shape({
    iteratees: PropTypes.array,
    orders: PropTypes.array,
  }),
  required: PropTypes.bool,
  width: PropTypes.oneOf(_.values(FIELD_WIDTH)),
};

ListerSingleSelect.defaultProps = {
  width: FIELD_WIDTH.M,
};
